/**
 * ? @description : Comments Modal Component
 */

// Dependencies
import React, { memo, useState } from "react";
import { Modal, Form, FloatingLabel } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../axios/Axios";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";
import { LoadingButton } from "@mui/lab";
import {  Typography } from "@mui/material";
import { useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";

//Tooltip to view message
// const StyledTooltip = ({ className, ...props }) => (
//   <Tooltip {...props} classes={{ tooltip: className }} />
// );
// const ShowFullText = styled(StyledTooltip)(({theme}) => ({
//   backgroundColor: 'white',
//   color: 'black',
//   maxWidth: 500,
//   fontSize: "15px",
//   boxShadow: theme.shadows[5]
// }));

export default memo(function CommentsModal(props) {
  // console.log(props);
  const dispatch = useDispatch();

  // * Logged Username
  let username = sessionStorage.getItem("user_id");

  // * Selected Row Data Value
  const id = props.tabledata[0];

  // let name = props.tabledata[1];


  // * State Variables
  const [commentLists, setCommentLists] = useState([]);
  const [commentData, setCommentData] = useState({
    comment_priority: "normal",
    comment_description: "",
  });
  const [loading, setLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  // console.log(props.tabledata);

  // ? API Call : Post Method : Comments Data
  async function postCommentsData(e) {
    // e.currentTarget.disabled = true

    try {
      const { comment_priority, comment_description } = commentData;

      if (comment_description !== "") {

        setLoading(true);
        let commentObject;
        switch (props.modalname) {
          case "mappingcomments":
            commentObject = {
              comment_priority: comment_priority,
              comment_desc: comment_description,
              map_id: props.tabledata[0],
              teacher_id: props.tabledata[1],
              student_id: props.tabledata[3],
              created_by: username
            }
            break;
          case "studentcomments":
            commentObject = {
              comment_priority: commentData.comment_priority,
              comment_desc: commentData.comment_description,
              student_id: props.tabledata[0],
              created_by: username
            }
            break;
          case "teachercomments":
            commentObject = {
              note_priority: commentData.comment_priority,
              note_description: commentData.comment_description,
              teacher_id: props.tabledata[0],
              teacher_name: props.tabledata[1].props["aria-label"],
              note_created_by: username,
            }
            break;
          case "calloutcomments":
            commentObject = {
              comment_desc: commentData.comment_description,
              callout_id: props.tabledata[0],
              comment_priority: commentData.comment_priority,
              created_by: username
            }
            break;
          case "admincomments":
            commentObject = {
              comment_desc: commentData.comment_description,
              user_id: props.tabledata[0],
              user_type: "admin",
              comment_priority: commentData.comment_priority,
              created_by: username
            }
            break;
          case "spoccomments":
            commentObject = {
              comment_desc: commentData.comment_description,
              user_id: props.tabledata[0],
              user_type: "spoc",
              comment_priority: commentData.comment_priority,
              created_by: username
            }
            break;
          default:
            break;
        }
        // console.log(commentObject);
        // * Options
        let options = {
          method: "POST",
          url: props.postcomment,
          auth: true,
          data: commentObject,
        };

        // * Post Data
        let response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
        // console.log(response);
        if (response.status === 200 || 201) {
          setCommentData({ comment_priority: "normal", comment_description: "" })
          setLoading(false)
          dispatch(
            showSnackbar({
              message: "Comments added successfully !",
              severity: "success",
            })
          );
        }
      } else {
        setButtonClicked(true)
        dispatch(
          showSnackbar({
            message: "Please fill all the required fields !",
            severity: "error",
          })
        );
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
      dispatch(
        showSnackbar({
          message: "Error occurred while posting comments.",
          severity: "error",
        })
      );
    }
  }

  // * Columns Declaration for Table
  const columns = [
    {
      headerName: "Priority",
      field: "note_priority",
      filter: true,
      sortable: true,
      cellStyle: (params) =>
        params.value === "high"
          ? { color: "red", fontWeight: "bold" }
          : { color: "green", fontWeight: "bold" },
    },
    {
      headerName: "Description",
      field: "note_description",
      filter: true,
      sortable: true,
      minWidth: 550,
      cellRenderer: (params) => {
        return (
          params.value !== null ?
            <Typography
              variant="p"
              sx={{
                height: "auto",
                lineHeight: 1.5,
                width: "100%",
                p: 1,
                wordBreak: "break-word"
              }}
            >
              {params.value}
            </Typography> :
            "-"
        )
      }
    },
    {
      headerName: "Action by",
      field: "action_by_name",
      filter: true,
      sortable: true,
    },
    {
      headerName: "Date",
      field: "note_created_at",
      filter: true,
      sortable: true,
      cellRenderer: (params) => {
        const formattedDate = dayjs(params.value).format("DD-MM-YYYY");
        return (
          !!params.value ? <span>{formattedDate}</span> : <span>Invalid date</span>
        );
        // return <span>{params.value}</span>
      },
    },
    {
      headerName: "Time",
      field: "note_created_at",
      filter: true,
      sortable: true,
      cellRenderer: (params) => {
        return <span>{DateFormatting(params)}</span>;
      },
    },
  ];

  // ! Time Formatting
  function DateFormatting(params) {
    let theDate = new Date(Date.parse(params.value)).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    });
    return theDate.split(", ")[1];
  }


  useEffect(() => {
    // ? API Call : Get Method : Fetch Data from Server
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `${props.getcomment}${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };

          let response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
            );

          if (response.status === 200 || response.status === 201) {
            let commentsData = response.data.map(data => {
              switch (props.modalname) {
                case "teachercomments":
                  return data;
                case "mappingcomments":
                case "calloutcomments":
                case "admincomments":
                case "spoccomments":
                case "studentcomments":
                  let { comment_priority, comment_desc, action_by_name, created_at } = data;
                  return {
                    note_priority: comment_priority,
                    note_description: comment_desc,
                    action_by_name: action_by_name,
                    note_created_at: created_at,
                  }
                default:
                  return data;
              }
            })

            setCommentLists(commentsData)
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            setCommentLists([])
            console.log(error);
            dispatch(
              showSnackbar({
                message: "Error occurred while fetching comments",
                severity: "error",
              })
            );
          }

        }
      }
    })();
    setButtonClicked(false)
    return () => {
      controller.cancel();
    }
  }, [loading, id, props.getcomment, props.modalname,dispatch])

  // to set the required for comment field 

  const isCommentValid = commentData.comment_description.length > 0 && commentData.comment_description.length < 200;
  const handleClose = () => {
    props.onHide();
    props.onCloseCallback();
    // window.location.reload(false);
    setCommentData({
      comment_priority: "normal",
      comment_description: "",
    })
  }
  return (
    // props.tabledata && (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div style={{ display: "flex" }}>
            <h5>Create / View comment</h5>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Table */}
        <div
          className="ag-theme-alpine my-2"
          style={{ width: "100%", height: "270px" }}
        >
          <AgGridReact
            defaultColDef={{
              flex: 1,
              sortable: true,
              resizable: true,
              filter: true,
              wrapText: true,
              autoHeight: true,
            }}
            rowData={commentLists}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={5}
            paginationAutoPageSize={true}
          />
        </div>

        {/* Form */}
        <label>Comments Priority</label>
        <Form.Control
          as="select"
          aria-label="Default select example"
          value={commentData.comment_priority}
          onChange={(e) => {
            setCommentData({ ...commentData, comment_priority: e.target.value });
          }}
        >
          <option value="normal"> Normal </option>
          <option value="high"> High </option>
        </Form.Control>

        <br />

        <label>Add comments</label>
        <FloatingLabel
          controlId="floatingTextarea2"
        >
          <Form.Control as="textarea" style={{ height: "100px" }}
            value={commentData.comment_description}
            onChange={(e) => {
              if (commentData.comment_description.length < 200) {
                setCommentData({
                  ...commentData,
                  comment_description: e.target.value,
                });
              }
            }}
            required
            isInvalid={buttonClicked && !isCommentValid}
          />
          <Form.Control.Feedback type="invalid" style={{ fontWeight: '700' }}>
            * Please enter a reason between 1 and 199 characters
          </Form.Control.Feedback>
        </FloatingLabel>
        {/* {!isCommentValid && (
          <Alert variant="danger" style={{ marginTop: '8px' }}>
            Please enter a reason between 1 and 199 charactersbnm
          </Alert>
        )} */}
      </Modal.Body>

      <Modal.Footer style={{ gap: "25px" }}>
        {/* <Button color="inherit" variant="contained" onClick={() => {
            props.onHide();
            setCommentData({
              comment_priority: "normal",
              comment_description: "",
            })
            
          }}>
            CANCEL
          </Button> */}
        <LoadingButton
          size="medium"
          onClick={() => postCommentsData()}
          loading={loading}
          variant="contained"
        >
          Submit
        </LoadingButton>
      </Modal.Footer>
    </Modal>
  )
  // );
})